import { useEffect } from 'react';
import SuppliersHeroFr from './components/SuppliersHeroFr';
import PartnerIntroSectionFr from './components/PartnerIntroSectionFr';
import SupplierApplicationFormFr from './components/SupplierApplicationFormFr';

const SUPPLIERS_SCHEMA_FR = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/fournisseurs#webpage`,
  url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/fournisseurs`,
  name: 'Fournisseurs Partenaires | MAX-Sourcing Réseau mondial de produits chimiques et pharmaceutiques',
  description:
    'Rejoignez le réseau de fournisseurs MAX-Sourcing. Nous collaborons avec des fabricants certifiés cGMP d\'IPA pharmaceutiques, de produits chimiques fins, d\'ingrédients alimentaires et de produits chimiques industriels dans le monde entier.',
  inLanguage: 'fr',
  isPartOf: {
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
  },
  dateModified: '2026-04-07',
  about: {
    '@type': 'Organization',
    name: 'MAX-Sourcing',
    url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
  },
  translationOfWork: {
    '@type': 'WebPage',
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/suppliers#webpage`,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/suppliers`,
    inLanguage: 'en',
  },
  workTranslation: {
    '@type': 'WebPage',
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/suppliers#webpage`,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/suppliers`,
    inLanguage: 'en',
  },
};

export default function SuppliersFrPage() {
  useEffect(() => {
    document.title = 'Fournisseurs Partenaires | MAX-Sourcing Réseau mondial de produits chimiques et pharmaceutiques';
    const id = 'schema-suppliers-fr';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SUPPLIERS_SCHEMA_FR);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <main className="flex-1">
        <SuppliersHeroFr />
        <PartnerIntroSectionFr />
        <SupplierApplicationFormFr />
      </main>
    </div>
  );
}
